import { Checkbox, Chip, Icon } from '@wework/dieter-ui'
import PopupAwayClick from '../PopupAwayClick'
import React, { useState } from 'react'

export default function CheckboxFilterControl({
  onChecked,
  checkBoxes,
  label,
  disabled,
}: any) {
  const [open, setOpen] = useState(false)
  const renderCheckBoxes: any = []

  const chipLabel: any = []

  const handleChange = (index: number, data) => {
    const changedCheckBoxes = [...checkBoxes]
    changedCheckBoxes[index].checked = data.checked
    const keys: any = []

    changedCheckBoxes.forEach(c => {
      if (c.checked) {
        keys.push(c.key)
      }
    })

    onChecked(changedCheckBoxes, keys)
  }

  checkBoxes.forEach((c, index) => {
    if (c.checked) {
      chipLabel.push(c.name)
    }
    renderCheckBoxes.push(
      <div key={c.name} style={{ width: '210px', padding: 8 }}>
        <Checkbox
          checked={c.checked}
          onChange={(e, data) => handleChange(index, data)}
          value={c.name}
          label={c.name}
        />
      </div>
    )
  })

  const onDelete = () => {
    const changedCheckBoxes = [...checkBoxes]

    for (let i = 0; i < changedCheckBoxes.length; i += 1) {
      changedCheckBoxes[i].checked = false
    }

    onChecked(changedCheckBoxes, [])
    handleClose()
  }

  const handleClick = () => {
    setOpen(!open)
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <PopupAwayClick
      open={open}
      setter={setOpen}
      position="bottom left"
      closeOnTriggerMouseLeave={true}
      disabled={disabled}
      trigger={
        <Chip onClick={handleClick} primary={chipLabel.length > 0}>
          {chipLabel.length > 0 ? chipLabel.join(', ') : label}
          <div
            style={{ display: 'inline', marginLeft: 8 }}
            onClick={() => {
              onDelete()
            }}
          >
            <Icon fitted name={open ? 'x' : 'caret down'} />
          </div>
        </Chip>
      }
      on="click"
      content={<div>{renderCheckBoxes}</div>}
    />
  )
}
